import { useGlobalErrorHandler } from "../../hooks/useGlobalErrorHandler"

export const GlobalErrorHandler = () => {
  useGlobalErrorHandler()

  return null
}
